module.exports = __webpack_public_path__ + "static/media/ispe.33161ca8.png";